"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToHilSignalBlockInfo = mapToHilSignalBlockInfo;
exports.mapFromHilSignalBlockInfo = mapFromHilSignalBlockInfo;
function mapToHilSignalBlockInfo(signalBlockInfo) {
    return {
        name: signalBlockInfo.name ?? null,
        blockPattern: signalBlockInfo.blockPattern ?? null,
        index: signalBlockInfo.index,
    };
}
function mapFromHilSignalBlockInfo(hilSignalBlockInfo) {
    return {
        name: hilSignalBlockInfo.name ?? undefined,
        blockPattern: hilSignalBlockInfo.blockPattern ?? undefined,
        index: hilSignalBlockInfo.index,
    };
}
//# sourceMappingURL=signal-block-info.mapper.js.map